import Vue from "vue";
Vue.config.productionTip = false;
import Vuex from "vuex";
import { GetSystemConfig } from "@/api/config";
import { CheckToken } from "@/api/login";
import $api from "@/api/index.js";
import { baseUrl } from "./config/env";
import router from "./router";
// import { Message } from "element-ui";
import {
  delCookie,
  buildLoginRedirectQuery,
  clearAuthRedirectPath,
  getAuthRedirectPath,
  navigateToLoginWithRedirect,
} from "./utils/util";
Vue.use(Vuex);

/**
 * systemConfig 获取到的clientUIConfig
 * 在admin端设置隐藏后在client端获取控制显示隐藏
 * 目前定义类型如下，如需增加，需要在admin端的系统配置页面里面添加固定json类型
 * 然后在client里做相应的隐藏处理
 * 
 * checkData: {
  "changLanguage": {
    label: "语言切换",
    icon: 'icons-zw',
    size: '35px',
    isHapped: true
  },
  "fullScreen": {
    label: "全屏",
    icon: 'icons-pq',
    size: '15px',
    isHapped: true
  },
  "reportTool": {
    label: "报表辅助设置",
    icon: 'icons-jurassic_toolkit',
    size: '20px',
    isHapped: true
  },
  "photo": {
    label: '头像',
    src: this.userImage || photoImg,
    isHapped: true
  },
  'find': {
    label: '发现',
    icon: 'icons-explore',
    size: '24px',
    isHapped: true
  },
  "report": {
    label: '报表',
    icon: 'icons-baobiao2',
    size: '18px',
    isHapped: true
  },
  "desgin": {
    label: '设计',
    icon: 'icons-design',
    size: '18px',
    isHapped: true
  },
  'my': {
    label: '我的',
    icon: 'icons-user',
    size: '20px',
    isHapped: true
  },
  'listChange': {
    label: '列表切换',
    src: list_change,
    isHapped: true
  },
},
 */
const systemType = "earthClient";
// const systemType = "jd"
// const systemType = "zongteng"
// const systemType = "ATL"
// const systemType = "kaiBo"

const state = {
  appName: "client",
  adminName: "admin",
  theme: localStorage.theme || "",
  basicStaticImgUrl: process.env.NODE_ENV == "development" ? "/" : "",
  defaultLogoBanner:
    process.env.NODE_ENV == "development"
      ? "/static/logo_banner.png"
      : "static/logo_banner.png",
  defaultPhoto:
    process.env.NODE_ENV == "development"
      ? "./static/photo.png"
      : "static/photo.png",
  defaultLogo:
    process.env.NODE_ENV == "development"
      ? "/static/logo.png"
      : "static/logo.png",
  systemType: systemType,
  LicenseStatus: false, //判断授权状态是否异常，true为异常
  clientGlobalRole:
    localStorage.clientGlobalRole &&
      localStorage.clientGlobalRole !== "undefined" &&
      localStorage.clientGlobalRole !== "" &&
      localStorage.clientGlobalRole !== "null"
      ? localStorage.clientGlobalRole
      : "",
  timeOut: false,
  user: {},
  isBarrage: true,
  commentBarrage: true,
  platform: "pc", //用来记录当前系统是要渲染移动端还是pc端
  findSearch: true, //记录发现页面的scroll时候是否显示底部收藏
  language: "",
  alertStatus: false,
  clientToken: localStorage.clientToken || "",
  globalLoading: false,
  systemConfig: {},
  isShowDesign: false, //是否显示设计菜单
  isSelfServiceAnalysis: false, //是否显示自助分析入口
  isXiaoQReport: false, //是否显示小Q报告入口
  isXiaoQQuery: false, //是否显示小Q问数入口
  isSelfServiceDownload: false, //是否显示自助取数入口
  isEDC: false,
  isBI: false,
  isRobot: false, //是否为机器人用户
  isPortal: false, //是否为portal或者report权限，用来控制菜单的显示隐藏
  isShowPortal: true, //是否为portal用户，控制社交模块是否显示
  isCard: false, //卡片功能控制显示隐藏
  // portal包含功能【评论，报表推荐，评分，标签，社交，分享】如果用户类型不包含portal则这些都不显示
  adminInfo: {
    userImage: "",
  },
  passwordPolicy: 1, //密码策略类型，需要在修改密码弹窗内获取类型，判断用哪种前端正则的限制
  reportStyleType:
    systemType == "HK" ? "table" : sessionStorage.reportStyleType || "grid", //报表展示方式（table或grid）
  toolBar: {
    /* 报表工具栏状态*/
    drawerType: "" /* sharePages drawerComment report */,
    isShow: false,
    comment: false /**讨论右边弹窗是否展开和讨论图标是否点亮 */,
    report: false /* 报表相关右边弹窗是否展开和报表相关图标是否点亮*/,
  },
  jdReportBack: localStorage.getItem("jdReportBack") || "", //京东报表返回按钮存的type值
  scrollInfo: {
    scrollTop: 0,
    viewList: [],
    params: {},
    totalCount: 0,
  }, // 插件市场记录滚动条
  waterMaskText: {},
  newCommentCount: 0,
  newMessageCount: 0,
  atMsg: 0,
  disMe: 0,
  annoMsg: 0, //公告消息
  loginMsg: 0,
  fansMsg: 0,
  editUserMsg: 0,
  systemmsg: 0, //loginmsg + editUserMsg的总和，它俩被归类为系统消息
  messageSocket: null,
  msgData: [], //左上角我的消息
  socketType: null,
  braggerData: [], //弹幕的消息
  uiConfig: {
  },
  pusheditData: [],
  taskPushConfigId: 0,
  taskid: 0, //0 
  isups: false
};

function clearAuthSessionState(state) {
  const keys = [
    "clientToken",
    "clientGlobalRole",
    "checkClientUser",
    "clientIsBarrage",
    "jdReportBack",
    "theme",
    "clientReturnUrl",
  ];
  keys.forEach((item) => {
    localStorage.removeItem(item);
  });
  sessionStorage.removeItem("clientDefaultUrl");
  if (!localStorage.token || localStorage.token.length < 20) {
    delCookie();
  }
  state.user = {};
  state.clientToken = "";
}

const mutations = {
  setCount(state, count) {
    state.newCommentCount = count.commentCount;
    state.newMessageCount = count.msgCount;
    state.atMsg = count.atMsg;
    state.disMe = count.disMe;
    state.annoMsg = count.annoMsg;
    state.loginMsg = count.loginMsg || 0;
    state.fansMsg = count.fansMsg;
    state.editUserMsg = count.editUserMsg || 0;
    state.systemmsg = state.loginMsg + state.editUserMsg;
  },
  setTheme(state) {
    if (state.theme == "light") {
      state.theme = "";
      localStorage.removeItem("theme");
    } else {
      state.theme = "light";
      localStorage.theme = "light";
    }
  },
  setDrawerType(state, type) {
    if (type == state.toolBar.drawerType) {
      state.toolBar.isShow = false;
      state.toolBar.drawerType = "";
    } else {
      state.toolBar.isShow = true;
      state.toolBar.drawerType = type;
    }
  },
  closeDrawer() {
    state.toolBar.isShow = false;
  },
  clearDrawerType(state) {
    state.toolBar.drawerType = "";
  },
  setJdReportBack(state, status) {
    if (status) {
      localStorage.jdReportBack = JSON.stringify(status);
      state.jdReportBack = localStorage.getItem("jdReportBack");
    } else {
      localStorage.removeItem("jdReportBack");
      state.jdReportBack = "";
    }
  },
  setPasswordPolicy(state, type) {
    state.passwordPolicy = type;
  },
  setCommentBarrage(state, status) {
    state.commentBarrage = status;
  },
  setIsShowDesign(state, status) {
    state.isShowDesign = status;
  },
  setIsEDC(state, status) {
    state.isEDC = status;
  },
  setIsShowPortal(state, status) {
    state.isShowPortal = status;
  },
  setGlobalRole(state, val) {
    state.clientGlobalRole = val || "";
    if (state.clientGlobalRole) {
      localStorage.clientGlobalRole = state.clientGlobalRole;
    } else {
      localStorage.removeItem("clientGlobalRole");
    }
  },
  setLicenseStatus(state, type) {
    state.LicenseStatus = type || false;
  },
  setTimeOut(state, type) {
    state.timeOut = type;
  },
  setUser(state, obj) {
    state.user = obj;
    if (state.user.userImage) {
      state.user.userImage = baseUrl + state.user.userImage;
    } else {
      state.user.userImage = state.defaultPhoto;
    }
  },
  setToolBarComment(state, type) {
    state.toolBar.comment = type;
    state.toolBar.report = false;
  },
  setToolBarReport(state, type) {
    state.toolBar.report = type;
    state.toolBar.comment = false;
  },
  setIsBarrage(state, type) {
    state.isBarrage = type;
  },
  clearAuthSession(state) {
    clearAuthSessionState(state);
  },
  logout(state, payload = {}) {
    let returnUrl = localStorage.getItem("clientReturnUrl");
    const redirectPath =
      payload.redirectPath || getAuthRedirectPath() || undefined;
    const loginRedirectQuery = buildLoginRedirectQuery(redirectPath);
    const existingRedirect = router.currentRoute.query && router.currentRoute.query.redirect;
    const query = {
      ...loginRedirectQuery,
      ...(existingRedirect && !loginRedirectQuery.redirect
        ? { redirect: existingRedirect }
        : {}),
    };

    if (returnUrl) {
      returnUrl = decodeURI(returnUrl);
      localStorage.removeItem("returnUrl");
      clearAuthSessionState(state);
      window.location = returnUrl;
      return;
    }

    const isSsoOut = !!localStorage.clientisssoout;
    const isDisableSSO = !!localStorage.disableSSO;
    if (isSsoOut) {
      localStorage.removeItem("clientisssoout");
    }

    clearAuthSessionState(state);

    if (payload.skipNavigate) {
      return;
    }

    if (Object.keys(query).length || isDisableSSO) {
      navigateToLoginWithRedirect(redirectPath);
      return;
    }

    if (isSsoOut) {
      router.push({ name: "login", query });
    } else if (isDisableSSO) {
      router.push({ name: "login", query: { disableSSO: true } });
    } else {
      router.push({ name: "login", query });
    }
  },
  /**不设置本地存储的登录token */
  setNoLocalStorageLogin: async (state, data) => {
    state.clientToken = data.token;
  },
  setUserLanguage(state, lang) {
    state.language = lang;
    localStorage.language = lang;
  },
  setGlobalLoading(state, type) {
    state.globalLoading = type;
  },
  setToken(state, token) {
    if (token) {
      state.clientToken = token;
      localStorage.clientToken = token;
      // 与 CheckToken 对齐：写入 cookie，供浏览器全页跳转（EasySSO 等）鉴权
      try {
        const maxAge = 2 * 24 * 60 * 60;
        // 与 Access/CheckToken 一致：cookie 存原始 JWT，供全页跳转鉴权
        document.cookie = `token=${token}; path=/; max-age=${maxAge}`;
      } catch (e) {
        /* ignore */
      }
      clearAuthRedirectPath();
    }
  },
  clearToken(state) {
    state.clientToken = "";
    localStorage.removeItem("clientToken");
    try {
      document.cookie = "token=; path=/; max-age=0";
    } catch (e) {
      /* ignore */
    }
  },
  settingSystemConfig(state, systemConfig) {
    let logoPicture = state.defaultLogo;

    if (systemConfig) {
      if (systemConfig.logoPicture) {
        logoPicture = systemConfig.logoPicture;
      }
      document.querySelector("title").innerHTML =
        systemConfig.systemName || "观数台";

      if (systemConfig.clientCustomMenu) {
        let clientMenuData = JSON.parse(systemConfig.clientCustomMenu);
        systemConfig.clientCustomMenuEnabled = clientMenuData.Enabled || false;
        systemConfig.clientCustomMenuTitle = clientMenuData.Title || "";
      } else {
        systemConfig.clientCustomMenuEnabled = false;
        systemConfig.clientCustomMenuTitle = "";
      }
    } else {
      document.querySelector("title").innerHTML = "观数台";
    }

    systemConfig.logoPicture = logoPicture;

    state.systemConfig = systemConfig;

    if (
      !state.systemConfig.angleOfView ||
      state.systemConfig.angleOfView != 2
    ) {
      state.clientGlobalRole = "";
      localStorage.removeItem("clientGlobalRole");
    } else if (
      state.systemConfig.angleOfView ||
      state.systemConfig.angleOfView == 2
    ) {
      if (!state.clientGlobalRole || !localStorage.clientGlobalRole) {
        // 如果切换视角模式后没有角色就跳到角色

        if (
          !router.currentRoute.fullPath.includes("login") &&
          !router.currentRoute.fullPath.includes("CheckLicense") &&
          router.currentRoute.fullPath != "/"
        ) {
          //如果当前是login或者home 说明还未登录成功，不能进行二次CheckLicense跳转，只用在登录期间，管理端切换了角色模式，本地刷新的时候判断跳转用
          router.push({ name: "CheckLicense" });
        }
      }
    }
  },
  saveAdminInfo(state, adminInfo) {
    state.adminInfo = adminInfo;
  },
  closeDeleteAlert(state) {
    state.alertStatus = false;
  },
  openDeleteAlert(state) {
    state.alertStatus = true;
  },
  setReportStyleType(state, val) {
    state.reportStyleType = val;
    sessionStorage.setItem("reportStyleType", val);
  },
  setPlatform(state, str) {
    /**
     * @param str 传入一个string类型，可选参数为 pc m
     */
    state.platform = str || "pc";
  },
  setIsBI(state, type) {
    state.isBI = type;
  },
  setIsPortal(state, type) {
    state.isPortal = type;
  },
  setIsRobot(state, type) {
    state.isRobot = type;
  },
  setIsSelfServiceAnalysis(state, type) {
    state.isSelfServiceAnalysis = type;
  },
  setIsXiaoQReport(state, type) {
    state.isXiaoQReport = type;
  },
  setIsXiaoQQuery(state, type) {
    state.isXiaoQQuery = type;
  },
  setIsSelfServiceDownload(state, type) {
    state.isSelfServiceDownload = type;
  },
  setIsCard(state, type) {
    state.isCard = type;
  },

  setScroll(state, val) {
    state.scrollInfo = val;
  },
  setWaterMask(state, val) {
    state.waterMaskText = val;
  },
  setSocket(state, object) {
    state.messageSocket = object;
  },
  socketMessage(state, msg) {
    if (!msg.data) return;
    let msgData = [];

    if (msg.isHttp) {
      // http请求获取的数据
      msgData = msg.data;
    } else {
      // socket获取的数据
      let serializeData = JSON.parse(msg.data);
      const { data, socketType } = serializeData;
      state.braggerData = null;
      if (
        (socketType == 2 && data && data == 2) ||
        (socketType == 3 && data && data.state && data.state !== 1)
      ) {
        // 在线用户被迫下线 在线产品用户下线
        state.socketType = socketType;
      } else if (socketType == 4 && data) {
        // 评论弹幕;
        state.braggerData = data;
        state.socketType = socketType;
      } else {
        state.socketType = null;
      }
      if (socketType !== 1) return;
      msgData = data;
    }

    //京东只展示公告信息
    if (state.systemType == "jd") {
      msgData = msgData.filter((item) => item.messageFrom == 4);
    }

    state.msgData = msgData;
  },
  setMsgData(state, obj) {
    state.msgData = obj;
  },
  setBraggerData(state, data) {
    state.braggerData = data;
  },
  setSocketType(state, type) {
    state.socketType = type;
  },
  ADD_CONFIG(state, data) {
    state.uiConfig = data;
  },
};

const CheckTokenSync = (commit, token) =>
  CheckToken({
    token: token || localStorage.clientToken,
    orderNumber: 0,
  })
    .then((res) => {
      if (res && res.isSuccess && res.data.tokenAccess) {
        commit("setToken", res.data.tokenAccess);
      } else {
        commit("logout");
      }
    })
    .catch(() => {
      commit("logout");
    });

const actions = {

  connectSocket({ commit, state }) {
  if (!state.clientToken) return;
  
  const { protocol, hostname, pathname, port } = window.location;
  let currentPort = port ? ":" + port : "";
  let wsIp = "";

  if (process.env.NODE_ENV == "development") {
    wsIp = baseUrl.split("//")[1];
  } else {
    let index = pathname.indexOf("/" + state.appName);
    let queryName = pathname.substring(0, index);
    wsIp = hostname + currentPort + queryName;
  }

  let _ws = protocol == "http:" ? "ws" : "wss";
  
  // 使用子协议传递 token，URL 中只保留必要参数
  const wsUri = `${_ws}://${wsIp}/messagewebsocket/?userId=${state.user.id}&clientType=1&clientModule=1`;
  
  commit("setSocket", new WebSocket(wsUri, [`${state.clientToken}`]));
},


  async getChangeConfig({ commit }) {
    await $api.SystemConfig.GetItem().then((res) => {
      if (res && res.data) {
        if (res.data.isCommentBarrage != undefined) {
          commit("setCommentBarrage", res.data.isCommentBarrage);
        }
        if (res.data.waterMarkTextJson) {
          commit("setWaterMask", JSON.parse(res.data.waterMarkTextJson));
        }
      }
    });
  },
  async getCurrentUser({ commit }) {
    const res = await $api.Users.GetCurrentUser();
    if (res && res.isSuccess) {
      commit("setUser", res.data || {});

      const { userType, biProductUser } = res.data;

      if (userType) {
        let isSelfServiceAnalysis = userType.some((item) => item == 128);
        commit("setIsSelfServiceAnalysis", isSelfServiceAnalysis);

        let isXiaoQReport = userType.some((item) => item == 256);
        commit("setIsXiaoQReport", isXiaoQReport);

        let isXiaoQQuery = userType.some((item) => item == 1024);
        commit("setIsXiaoQQuery", isXiaoQQuery);

        let isSelfServiceDownload = userType.some((item) => item == 512);
        commit("setIsSelfServiceDownload", isSelfServiceDownload);

        let isCard = userType.some((item) => item == 64);
        commit("setIsCard", isCard);

        let isRobot = userType.some((item) => item == 32);
        if (isRobot) {
          commit("setIsRobot", true);
        }
        let isEDC = userType.some((item) => item == 2);
        commit("setIsEDC", isEDC);
        if (!isEDC && state.uiConfig.myTask !== "off") {
          const newConfig = { ...state.uiConfig, myTask: "off" };
          commit("ADD_CONFIG", newConfig);
        }
        let isBI = userType.some((item) => item == 8);
        commit("setIsBI", isBI);
        commit("setIsShowDesign", isBI && biProductUser && biProductUser.type == 2);

        let isPortal = userType.some((item) => item == 1 || item == 4);
        commit("setIsPortal", isPortal || isBI);

        let isShowPortal = userType.some((item) => item == 1);
        commit("setIsShowPortal", isShowPortal);
      }
      return res;
    }
    throw new Error("GetCurrentUser failed");
  },
  async GetCurrentSystemConfig({ commit }) {
    try {
      const res = await GetSystemConfig();

      if (res && res.isSuccess) {
        commit("settingSystemConfig", res.data);

        commit(
          "setPasswordPolicy",
          res.data.passwordPolicyModel ? res.data.passwordPolicyModel.type : 1
        );
        const httpConfig = res.data.clientUIConfig;
        if (httpConfig) {
          let newConfig = { id: "client" };
          for (const key in httpConfig) {
            if (Object.hasOwnProperty.call(httpConfig, key)) {
              newConfig[key] = httpConfig[key];
              if (key == "reportDefaultDisplayTable" && httpConfig[key]) {
                const type = httpConfig[key] == "true" ? "table" : "grid";
                commit("setReportStyleType", type);
              }
            }
          }
          commit("ADD_CONFIG", newConfig);
        }

      } else {
        commit("settingSystemConfig", {});
        throw new Error(res.message || "请求错误");
      }
    } catch (err) {
      commit("settingSystemConfig", {});
    }
  },

  setTimeCheckToken({ commit }, token) {
    CheckTokenSync(commit, token);
  },
};

const getters = {
  getLanguage: () => {
    let language = "en";

    language =
      localStorage.language && localStorage.language !== "undefined"
        ? localStorage.language
        : window.navigator &&
          window.navigator.language &&
          window.navigator.language == "zh-CN"
          ? "zh"
          : "en";

    return language;
  },
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
});
